module.exports = __webpack_public_path__ + "images/Feedback - Correct.svg";